import type { RouteRecordRaw } from 'vue-router'

export const imagePreview: RouteRecordRaw = {
	component: () => import('@/components/templates/ImagePreview.vue'),
	name: 'imagePreview',
	path: 'image',
	props: true,
	meta: {
		breadcrump: 'Bildanzeige',
		title: 'Bildanzeige',
		icon: 'fa-fw fas fa-image',
		auth: true,
		nav: false,
		offline: false,
	},
}
